// processWorkWithUs.tsx
// Detects and extracts the workwithus object from a <section id="workwithus">, replaces the section with a placeholder, and returns { html, workWithUsData }

export interface WorkWithUsData {
    header: string;
    title: string;
    imageUrl: string;
    content: string;
}

export interface ProcessedWorkWithUsResult {
    html: string;
    workWithUsData: WorkWithUsData | null;
}

export function processWorkWithUs(html: string): ProcessedWorkWithUsResult {
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const section = doc.querySelector('#workwithus');
        let workWithUsData: WorkWithUsData | null = null;
        if (section) {
            const script = section.querySelector('script[type="application/json"]');
            if (script && script.textContent) {
                let jsonText = script.textContent.trim();
                // Optionally fix single quotes to double quotes for JSON validity
                jsonText = jsonText.replace(/'/g, '"');
                try {
                    workWithUsData = JSON.parse(jsonText);
                } catch (e) {
                    // ignore parse errors
                }
            }
            if (workWithUsData) {
                section.replaceWith(document.createComment('WORKWITHUS_PLACEHOLDER'));
                return {
                    html: doc.body.innerHTML,
                    workWithUsData
                };
            }
        }
        return { html, workWithUsData: null };
    } catch (error) {
        return { html, workWithUsData: null };
    }
}
